<template>
  <div class="continuous-auctions-bidders-list page page-with-table p-2">
    <page-header class="mb-2" :title="$t('Bidders')"/>
    <div class="card content-wrapper p-2">
      <BiddersTable
          v-if="loadTable" :delete-permission="'delete_bidder'" :change-permission="'change_bidder'"
          :hide-actions="hideActions" :exclude-search-fields="['paddle_number']" :enable-export="false"
          :exclude-columns="['paddle_number', 'preferred_clerk', 'language', 'contact_number']">
      </BiddersTable>
    </div>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import BiddersTable from "./BiddersTable";
  import PageHeader from "../../core/components/page-header/PageHeader";
  import AddNewButton from "../../core/components/common/AddNewButton";
  import {ACTION_CREATE_NEW_BIDDER, ACTION_EDIT_BIDDER, ACTION_REMOVE_BIDDER} from "../constants";

  const {mapActions} = createNamespacedHelpers('bidders');
  const {mapState} = createNamespacedHelpers('global');

  export default {
    name: "BiddersList",
    components: {AddNewButton, PageHeader, BiddersTable},
    data() {
      return {
        hideActions: [
          ACTION_CREATE_NEW_BIDDER,
          // ACTION_EDIT_BIDDER,
          // ACTION_REMOVE_BIDDER,
        ],
        loadTable: true,
      }
    },
    computed: {
      ...mapState({
        enableContinuousAuction: state => state.enableContinuousAuction,
      }),
    },
    methods: {
      ...mapActions(['updateTableSource'])
    },
    async beforeMount() {
      if (this.enableContinuousAuction) {
        await this.updateTableSource({
          source: 'bidders',
          extraFilters: {
            auction_uuid: null
          }
        });
      } else if (this.$route.path === '/bidders') {
        this.loadTable = false;
        await this.$router.push({name: 'not-found'});
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "./scss/variables";

  .continuous-auctions-bidders-list {
    @include list-view-wrapper;
  }
</style>
